function getPrefferedLanguage () {
  let prefferedLanguage = 'en';
  let savedLanguage = window.localStorage.getItem('headwear-crm-ui-language');

  if (savedLanguage) {
    prefferedLanguage = savedLanguage;
  } else if (navigator && navigator.language) {
    prefferedLanguage = navigator.language;
    prefferedLanguage = prefferedLanguage.split('-');
    prefferedLanguage = prefferedLanguage[0];
  }

  if (['pl', 'en', 'de', 'fr', 'it'].indexOf(prefferedLanguage) === -1) {
    prefferedLanguage = 'en';
  }

  return prefferedLanguage;
}

export default getPrefferedLanguage;
